var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileWaveform = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-waveform",
    d: "M13,14a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V12H2v2a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V5.122a1.5,1.5,0,0,0-.441-1.059L9.941.441A1.5,1.5,0,0,0,8.881,0H4A2,2,0,0,0,2,2V9H3V2A1,1,0,0,1,4,1H8V4.5A1.5,1.5,0,0,0,9.5,6H13Zm-.016-9H9.5A.5.5,0,0,1,9,4.5V1.016a.477.477,0,0,1,.231.131l3.622,3.622A.492.492,0,0,1,12.984,5ZM8.447,8.275a.5.5,0,0,0-.894,0L5.916,11.553,4.9,10.2a.5.5,0,0,0-.4-.2H.5a.5.5,0,0,0,0,1H4.25L5.6,12.8a.5.5,0,0,0,.847-.078L8,9.619l.553,1.106A.5.5,0,0,0,9,11h2a.5.5,0,1,0,0-1H9.309L8.447,8.275Z",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileWaveform);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-waveform.575c5c3d47e8d13e5cdb4cb0c7c37914.svg";